module.exports = __webpack_public_path__ + "static/img/linefriends.02ec1b1e.png";